export class LL {
  getOptions() {
    return {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/i18n/date/MonthNameDayMonthYear.js
 **/